import { NotificationInline } from '../../../Notification'
import { useDocFlowMappingWidgetType } from '../../DocFlow.hooks'
import { DocFlowWidgetForm } from '../../DocFlowWidgetForm'

import { DocFlowMappingTypeWidgetFields } from './DocFlowMappingTypeWidgetFields'

import * as styles from './DocFlowMappingTypeWidget.module.css'

function DocFlowMappingTypeWidget({
  activeType,
  index,
  isSkeleton,
  ...widgetBaseProps
}) {
  const {
    disabled,
    handleClickNext,
    handleSubmitChangeType,
    isPagesOverlimit,
    nextButtonDisabled,
    notification,
    typeInProcess,
    widgetDone,
  } = useDocFlowMappingWidgetType({ itemIndex: index })

  return (
    <DocFlowWidgetForm
      {...widgetBaseProps}
      actionsProps={{
        disabled: nextButtonDisabled,
        isLoading: typeInProcess,
      }}
      done={widgetDone}
      index={index}
      initialValues={{ type: activeType }}
      isSkeleton={isSkeleton}
      onSubmit={handleClickNext}
    >
      {notification ? (
        <NotificationInline {...notification} className={styles.notification} />
      ) : null}

      <DocFlowMappingTypeWidgetFields
        disabled={disabled}
        isPagesOverlimit={isPagesOverlimit}
        typeInProcess={typeInProcess}
        onSubmitChangeType={handleSubmitChangeType}
      />
    </DocFlowWidgetForm>
  )
}

export default DocFlowMappingTypeWidget
